export const bidder_names = [
    'Display & Video 360',
    'AdForm',
    'The Trade Desk',
    'Xandr Invest',
    'Yahoo DSP',
    'Hawk (TabMo SAS)'
]

export const bidder_id = {
    'Display & Video 360': 101,
    'AdForm': 91,
    'The Trade Desk': 82,
    'Xandr Invest': 2,
    'Yahoo DSP': 183,
    'Hawk (TabMo SAS)': 405
}